// API utilities for standings
import { API_BASE_URL } from '../config';

export interface Standing {
  team_id: string;
  league: string;
  wins: number;
  losses: number;
  points_for: number;
  points_against: number;
  season: number;
  last_updated: string;
}

export interface StandingsResponse {
  success: boolean;
  standings: {
    [league: string]: Standing[];
  };
  lastUpdated: string | null;
}

export const standingsApi = {
  // Get current standings
  getStandings: async (): Promise<StandingsResponse> => {
    try {
      const response = await fetch(`${API_BASE_URL}/standings`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching standings:', error);
      throw error;
    }
  }
};

